import template from './branch.html';
import controller from './branch.controller';
import './branch.scss';

let branchComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default branchComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch/branch.component.js